// Author thq
// Date 2022-04-21 21:31:47

class EmEquipmentCategory {
constructor({
        id = null,
        name = '',
        seq = '',
        description = '',
        parentId = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.seq = seq;
    this.description = description;
    this.parentId = parentId;
}
}

function newEntity() {
return new EmEquipmentCategory();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.em.archive.emEquipmentCategory.grid.code',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'name',
        label: 'label.em.archive.emEquipmentCategory.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'enablestate',
        label: 'label.em.archive.emEquipmentCategory.grid.enablestate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'description',
        label: 'label.em.archive.emEquipmentCategory.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'level',
        label: 'label.em.archive.emEquipmentCategory.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'seq',
        label: 'label.em.archive.emEquipmentCategory.grid.seq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'parentName',
        label: 'label.em.archive.emEquipmentCategory.grid.parentName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,entity: 'emEquipmentCategory'
        }
        }
    ])}

const filter = {
    nameFilter : '',
    parentIdFilter : '',
    levelFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.archive.emEquipmentCategory.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.em.archive.emEquipmentCategory.filter.parentId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emEquipmentCategory'
            ,showLabelSelectOne: true
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.archive.emEquipmentCategory.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'seq',
        label: 'label.em.archive.emEquipmentCategory.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'description',
        label: 'label.em.archive.emEquipmentCategory.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'parentId',
        label: 'label.em.archive.emEquipmentCategory.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emEquipmentCategory'
            ,showLabelSelectOne: true
                }
        }
]

export {EmEquipmentCategory, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
